export default [

     {
          path: '/national-risk-prioritization',
          name: 'NationalRiskPrioritization',
          component: () => import("@/views/Page/NationalRiskPrioritization/NationalRiskPrioritization.vue"),
          meta: {
               title: 'National Risk Prioritization',
          },
     }
];